import React, {useContext, useEffect} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import BodyContentView from '../../views/bodyContentView';

function ZeroRestored({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;

    onExit();
  }, [rightPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit, onRight: onExit});
    });
  }, [onExit]);

  return (
    <BodyContentView
      title="Zero Restored"
      left="No"
      right="Finished"
      caption="Zero has been restored and applied."
    />
  );
}

export default ZeroRestored;
